import _lib from '../_lib';
import active from './active/index';
import {HealthRecordsNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'health_records';
  let activations = [
    {
      name: 'health_records',
      test: api.messageIs(HealthRecordsNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};

